import { Dayjs } from 'dayjs';
import { create } from 'zustand';
import { createDI } from '../../../context/di/di';
import { useApi, ApiResponse } from '../../../api/api';
import { TimeSlot } from '../../../constant';

/**
 * スケジュール一覧画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type ScheduleAction = {
  /**
   * スケジュール一覧取得
   * @param date
   * @param count
   * @param dataType
   * @param sections
   * @param divisionId
   * @param floor
   * @param block
   * @param start
   * @param end
   * @param textTypeKeys
   * @param content
   * @param timeSlot
   */
  getSchedules: (
    date: Dayjs,
    count: number,
    dataType?: string,
    sections?: string[],
    divisionId?: number,
    floor?: number,
    block?: number,
    start?: Dayjs,
    end?: Dayjs,
    textTypeKeys?: string,
    content?: string,
    timeSlot?: TimeSlot,
  ) => Promise<ApiResponse>;
};

/**
 * スケジュール一覧画面 状態とアクションを管理するための DI コンテキスト
 */
export type ScheduleStore = ScheduleAction;

/**
 * スケジュール一覧画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<ScheduleStore>();
export { Provider as ScheduleStoreProvider, use as useScheduleStore };

/**
 * スケジュール一覧画面 状態とアクション
 */
export const defaultScheduleStore = () => {
  const api = useApi();

  return create<ScheduleStore>(() => {
    return {
      getSchedules: async (
        date: Dayjs,
        count: number,
        dataType?: string,
        sections?: string[],
        divisionId?: number,
        floor?: number,
        block?: number,
        start?: Dayjs,
        end?: Dayjs,
        textTypeKeys?: string,
        content?: string,
        timeSlot?: TimeSlot,
      ) => {

        // リクエストパラメータ生成
        let param = '';
        param += `date=${date.format('YYYY-MM-DD')}`;
        param += `&count=${count}`;
        if (dataType != null && dataType !== '0') {
          param += `&type=${dataType}`;
        }
        if (sections != null) {
          param += `&sections=${sections.join(',')}`;
        }
        if (divisionId != null && divisionId !== 0) {
          param += `&division=${divisionId}`;
        }
        if (floor != null && floor !== 0) {
          param += `&floor=${floor}`;
        }
        if (block != null && block !== 0) {
          param += `&block=${block}`;
        }
        if (start && end) {
          param += `&start_time=${start.format('HH:mm:ss')}`;
          param += `&end_time=${end.format('HH:mm:ss')}`;
        } else if (timeSlot) {
          param += `&span_of_time=${timeSlot}`;
        }
        if (textTypeKeys && textTypeKeys !== '0') {
          param += `&textType=${textTypeKeys}`;
          if (content) {
            param += `&content=${encodeURIComponent(content)}`;
          }
        }
        console.log(`スケジュール一覧API ${param}`);

        // 実行
        const res = await api.path(`/api/works/schedules?${param}`).get();
        console.log(res.data);
        return res;

      },
    };
  });
};
